/* eslint-disable */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// constants
import { SUPERCHARGER_MARKER } from '../../lib/Constants';

// helpers
import MapUtils from '../../lib/MapUtils';
import MapMarkers from '../../lib/MapMarkers';

class Superchargers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chargerNetworkZoomListener: false,
      routeChargerListener: false,
      networkPlotted: false,
    };

    this.plotChargerNetwork = this.plotChargerNetwork.bind(this);
    this.initChargerNetworkZoomListener = this.initChargerNetworkZoomListener.bind(
      this,
    );
    this.initRouteChargerListener = this.initRouteChargerListener.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      chargerNetworkZoomListener,
      routeChargerListener,
      networkPlotted,
    } = this.state;

    const {
      mapLoaded,
      superchargers,
      routechargers,
      geolocation,
      entryPoint,
    } = this.props;

    if (mapLoaded && !chargerNetworkZoomListener && superchargers.length > 0) {
      this.initChargerNetworkZoomListener();
    }

    if (mapLoaded && !routeChargerListener && routechargers.length > 0) {
      this.initRouteChargerListener();
    }

    if (mapLoaded && !networkPlotted && superchargers.length > 0) {
      this.plotChargerNetwork();
    }

    // if user allowed geolocation then zoom to their current location
    if (networkPlotted && geolocation !== prevProps.geolocation) {
      MapUtils.zoomMap(10);
    }

    // if user came to app with an entry point then zoom to destination
    if (networkPlotted && entryPoint) {
      MapUtils.zoomMap(10);
    }
  }

  plotChargerNetwork() {
    const {
      superchargers,
      zoom,
      isMobile,
      chargerBody,
      errorMessage,
    } = this.props;

    this.setState({ networkPlotted: true });

    superchargers.map(charger => {
      const coords = {
        id: charger.id,
        lat: charger.geoPoint.lat,
        lng: charger.geoPoint.lon,
      };

      MapMarkers.setChargerNetworkMarker(
        coords,
        zoom,
        chargerBody,
        isMobile,
        SUPERCHARGER_MARKER,
        errorMessage,
      );

      if (isMobile) {
        MapMarkers.deleteMapMarker(coords);
      }

      return null;
    });
  }

  initChargerNetworkZoomListener() {
    const google = window.google;
    const map = window.map;

    this.setState({ chargerNetworkZoomListener: true });

    google.maps.event.addListener(map, 'zoom_changed', () => {
      const { superchargers, routechargers } = this.props;

      // if routchargers have been removed then restore the supercharger network
      if (routechargers.length === 0) {
        MapMarkers.updateChargerIconSize(superchargers);
      }
    });
  }

  initRouteChargerListener() {
    const google = window.google;
    const map = window.map;

    this.setState({ routeChargerListener: true });

    google.maps.event.addListener(map, 'zoom_changed', () => {
      const { routechargers, superchargers, isMobile } = this.props;

      if (isMobile) {
        MapMarkers.deleteMapMarkers(superchargers);
      }

      // resize route charger when a user changes zoom level
      MapMarkers.updateRoutechargerMarkers(routechargers);
    });
  }

  render() {
    return null;
  }
}

Superchargers.propTypes = {
  mapLoaded: PropTypes.bool.isRequired, // Lets the container know that the Map has loaded.
  superchargers: PropTypes.arrayOf(PropTypes.object).isRequired, // Network of superchargers for the google map
  zoom: PropTypes.number.isRequired, // Zoom level of the map
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  chargerBody: PropTypes.string.isRequired, // Details about superchargers that does not exist in TRT
  routechargers: PropTypes.arrayOf(PropTypes.object).isRequired, // Chargers along a users plotted trip
  geolocation: PropTypes.bool.isRequired, // True when the user has allowed geolocation data from browser
  entryPoint: PropTypes.bool.isRequired, // User loaded the application with prepopulated entry point
};

Superchargers.defaultProps = {};

const mapStateToProps = state => ({
  mapLoaded: state.GoogleMap.mapLoaded,
  superchargers: state.Superchargers.superchargers,
  zoom: state.GoogleMap.zoom,
  isMobile: state.App.isMobile,
  errorMessage: state.ErrorMsg.errors.somethingWrong,
  chargerBody: state.Superchargers.body,
  routechargers: state.Superchargers.routechargers,
  geolocation: state.GoogleMap.geolocation,
  entryPoint: state.GoogleMap.entryPoint,
});

export default connect(
  mapStateToProps,
  null,
)(Superchargers);
